// extracted by mini-css-extract-plugin
module.exports = {"popupContent":"ExtensionStep0_popupContent__K4WST","infoDiv":"ExtensionStep0_infoDiv__3CIbD","icon":"ExtensionStep0_icon__1HfXu","info":"ExtensionStep0_info__3sMjn"};